module.exports = __webpack_public_path__ + "assets/img/icon.0e4c7687.png";